import workflowHistory from './workflowHistory'

export default workflowHistory
